import endHeatSiren from "./normalized_end_heat_siren.m4a";
import { useAudio } from "./useAudio";

export const useEndSirenAudio = () => {
    const { play } = useAudio(endHeatSiren);
    return { playEndSirenSound: play };
};
